<template>
  <div class="orderaction-list">
    <br/>
    <Toolbar>
      <template #left>
        <h1><v-icon large>mdi-alert-decagram</v-icon>{{$t('order.orderactions')}}</h1>
      </template>
    </Toolbar>
    <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
      <OrderActionFilter
          :values="filters"
          slot="filter"
      />
    </DataFilter>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>

        <v-flex lg12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @click:row="showHandler"
            @contextmenu:row="showHandlerExt"
            @update:options="onUpdateOptions"
          >
            <template slot="item.date" slot-scope="{ item }">
              {{ formatDateTime(item['date'], 'long') }}
            </template>
            <template slot="item.type" slot-scope="{ item }">
              <v-chip  class="ma-1 font-weight-bold"  label  color="secondary">{{ item['type'].name }}</v-chip>
            </template>
            <template slot="item.tags" slot-scope="{ item }">
              <div id="tags">
                <v-chip v-for="tag in item['tags']" :key="tag.id"
                        class="ma-1 font-weight-bold"

                        color="accent"
                >
                  {{ tag.name }}
                </v-chip>
              </div>
            </template>
            <template slot="item.file" slot-scope="{item}" v-if="item.file">
              {{item.file.filePath}}
              <v-btn
                  color="secondary"
                  class=""
                  @click="downloadFileByObject(item)"
              >
                {{ $t('global.download') }}
                <v-icon
                    right
                    dark
                >mdi-download
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
import OrderActionFilter from "../../components/orderaction/Filter.vue";
// import ActionCell from "../../components/ActionCell.vue";
import Toolbar from "../../components/Toolbar.vue";
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from "../../mixins/FileMixin";
import AccessMixin from "../../mixins/AccessMixin";
import DataFilter from "../../components/DataFilter.vue";

const servicePrefix = 'OrderAction';
export default {
  name: 'OrderActionList',
  servicePrefix,
  components: {
    DataFilter,
    Toolbar,
    // ActionCell,
    OrderActionFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.date'), value: 'date'},
        { text: this.$t('orderaction.titre'), value: 'titre'},
        { text: this.$t('orderaction.type'), value: 'type'},
        {text: this.$t('orderaction.tags'), value: 'tags'},
        { text: this.$t('orderaction.content'), value: 'content', sortable: false},
        { text: this.$t('orderaction.file'), value: 'file'},
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['date'], sortDesc : [true]},
      parentAdd: {
        '@id' : this.$route.params.id,
      },
    };
  },
  mixins: [ListMixin,  FileMixin, AccessMixin],
  computed: {
    ...mapFields('orderaction',{
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),

    ...mapGetters('orderaction', {
      items: 'list'
    }),

  },
  methods: {
    ...mapActions('orderaction', {
      getPage: 'fetchAll',
    }),
  }
}
</script>